import React, { PropsWithChildren } from "react";
import useSnackbar, { Context } from "./use-snackbar";
import Snackbar from "./snackbar";

const SnackbarContext = React.createContext<Context | null>(null) as React.Context<Context>;

const SnackbarProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { openSnackbar, state, setState } = useSnackbar();
  return (
    <SnackbarContext.Provider value={{ openSnackbar, state, setState }}>
      <Snackbar />
      {children}
    </SnackbarContext.Provider>
  );
};

export { SnackbarContext, SnackbarProvider };
